
import { computed, defineComponent } from 'vue';
import SIcon from 'SharedComponents/ui/Icon/SIcon.vue';
import { useRouter } from 'vue-router';
import { random } from 'SharedDir/utils/helpers';
import { useDeviceSize } from 'SharedDir/common/composables/useDeviceSize';

export default defineComponent({
  name: 'SidebarItem',
  components: { SIcon },
  props: {
    group: {
      type: Object,
      required: true,
    },
    iconNumber: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const router = useRouter();

    const iconName = [
      'user',
      'saving',
      'money',
      'home1',
      'home2',
      'heart',
      'education',
      'culture2',
      'culture1',
    ];
    const getServiceName = computed(() => {
      return props.group.name ?? '';
    });

    const getIconName = () => {
      if (iconName.length > props.iconNumber) {
        return `custom:${iconName[props.iconNumber]}`;
      }
      return `custom:${iconName[random([0, iconName.length - 1])]}`;
    };

    // FIXME: Поменять на проброс списка мер поддержки с фильтром по выбранной группе
    async function goToService() {
      emit('close');
      let reloadPage = false;
      if (router.currentRoute.value.name === 'services') {
        reloadPage = true;
      }
      await router.push({
        name: 'services',
        query: {
          groupId: (props.group.id as number).toString(),
        },
      });
      if (reloadPage) {
        router.go(0);
      }
    }

    const { isMobile } = useDeviceSize();

    return { props, getServiceName, goToService, getIconName, isMobile };
  },
});
